export default __webpack_public_path__ + "static/media/speech.7d386952.png";